
import React from 'react';
import { Bot, Target, Phone, BarChart3 } from 'lucide-react';

export function ProcessSection() {
  const steps = [
    {
      icon: Bot,
      title: "Deploy & Configure AI Agents",
      description: "Set up intelligent sales agents that match your tone, territory, and goals. Configure workflows, assign territories, and define handoff rules between AI and human reps."
    },
    {
      icon: Target,
      title: "Discover & Qualify Leads",
      description: "AI agents discover high-quality prospects, enrich contact data, score leads by conversion probability, and automatically qualify them using your custom criteria."
    },
    {
      icon: Phone,
      title: "Engage & Nurture Multi-Channel",
      description: "Execute coordinated campaigns across email, SMS, and voice calls. AI handles initial outreach while seamlessly handing off warm leads to your human team at the perfect moment."
    },
    {
      icon: BarChart3,
      title: "Analyze & Scale Performance",
      description: "Track AI agent performance, human handoff success rates, and campaign ROI. Use insights to optimize agent behavior and scale what works best."
    }
  ];

  return (
    <div className="py-20 px-4 bg-accent/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            How atWork<span className="text-yellow-400">.ai</span> Works — AI Agents, Human Intelligence, Perfect Results
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Your AI-powered sales engine works alongside your team to discover, engage, and close deals automatically
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center group">
              {/* Connection line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-gradient-to-r from-yellow-400 to-transparent transform translate-x-4"></div>
              )}
              
              <div className="relative z-10">
                <div className="relative inline-flex justify-center items-center w-16 h-16 bg-yellow-400 text-neutral-900 rounded-2xl mb-6 group-hover:scale-110 transition-transform">
                  <step.icon className="w-8 h-8" />
                  {/* Step count badge moved to top-right */}
                  <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-8 h-8 bg-muted text-yellow-400 rounded-full text-sm font-bold border-2 border-background">
                    {index + 1}
                  </span>
                </div>
                
                <h3 className="text-xl font-semibold text-foreground mb-4">{step.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
